module.exports = __webpack_public_path__ + "static/media/roxy1.a4857235.jpg";